var map = {
	"./desktop": [
		86121,
		9,
		46066,
		82587,
		99670,
		84576,
		67142,
		21603,
		49510,
		78878,
		67967,
		87795,
		11024,
		10927,
		95312,
		76998
	],
	"./desktop/": [
		86121,
		9,
		46066,
		82587,
		99670,
		84576,
		67142,
		21603,
		49510,
		78878,
		67967,
		87795,
		11024,
		10927,
		95312,
		76998
	],
	"./desktop/Indiaworldcases": [
		40726,
		9,
		46066,
		95312,
		77666
	],
	"./desktop/Indiaworldcases.js": [
		40726,
		9,
		46066,
		95312,
		77666
	],
	"./desktop/Indiaworldcases.scss": [
		32798,
		7,
		85233
	],
	"./desktop/index": [
		86121,
		9,
		46066,
		82587,
		99670,
		84576,
		67142,
		21603,
		49510,
		78878,
		67967,
		87795,
		11024,
		10927,
		95312,
		76998
	],
	"./desktop/index.js": [
		86121,
		9,
		46066,
		82587,
		99670,
		84576,
		67142,
		21603,
		49510,
		78878,
		67967,
		87795,
		11024,
		10927,
		95312,
		76998
	],
	"./mobile": [
		82082,
		9,
		46066,
		86209,
		67142,
		21603,
		49510,
		67675,
		25018,
		90489,
		95312,
		21147
	],
	"./mobile/": [
		82082,
		9,
		46066,
		86209,
		67142,
		21603,
		49510,
		67675,
		25018,
		90489,
		95312,
		21147
	],
	"./mobile/Indiaworldcases": [
		19657,
		9,
		46066,
		95312,
		54500
	],
	"./mobile/Indiaworldcases.js": [
		19657,
		9,
		46066,
		95312,
		54500
	],
	"./mobile/Indiaworldcases.scss": [
		66670,
		7,
		63624
	],
	"./mobile/index": [
		82082,
		9,
		46066,
		86209,
		67142,
		21603,
		49510,
		67675,
		25018,
		90489,
		95312,
		21147
	],
	"./mobile/index.js": [
		82082,
		9,
		46066,
		86209,
		67142,
		21603,
		49510,
		67675,
		25018,
		90489,
		95312,
		21147
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 58972;
module.exports = webpackAsyncContext;